var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pickl && Object.keys(_vm.pickl).length > 0
    ? _c(
        "div",
        { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h2", [_vm._v("@HOME CAPAS Details")]),
              _c("button", {
                staticClass: "close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$router.go(-1)
                  }
                }
              })
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "button",
                {
                  staticClass: "pull-right btn btn-positive",
                  attrs: { type: "button" },
                  on: { click: _vm.sendPicklStatsReport }
                },
                [_vm._v("Export User Report")]
              ),
              _c(
                "button",
                {
                  staticClass: "pull-right btn btn-negative",
                  staticStyle: { "margin-top": "2px", "margin-right": "5px" },
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#deletepicklpopup"
                  }
                },
                [_vm._v("Delete Pickl")]
              ),
              _vm._v("  \n\n      "),
              _c("br"),
              _vm._m(0),
              _c("div", { staticClass: "tab-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade in active",
                    attrs: { id: "pickl-details-section" }
                  },
                  [
                    _c("br"),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12 col-md-12" }, [
                        _c("div", { staticClass: "green-border-box" }, [
                          _c(
                            "h3",
                            {
                              staticStyle: {
                                "margin-left": "10px",
                                "margin-right": "10px"
                              }
                            },
                            [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v("Brand: " + _vm._s(_vm.pickl.brand.name))
                              ]),
                              _c("img", {
                                staticStyle: {
                                  width: "50px",
                                  "margin-left": "33%"
                                },
                                attrs: {
                                  src: _vm.pickl.brand.logo + "?w=150&q=50"
                                },
                                on: {
                                  error: function($event) {
                                    _vm.pickl.brand.logo = "/img/pickl-logo.png"
                                  }
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "pull-right",
                                  staticStyle: { "text-align": "right" }
                                },
                                [
                                  _vm._v(
                                    "Total Responses Requested: " +
                                      _vm._s(_vm.pickl.response_counter)
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "Responses Left: " +
                                      _vm._s(_vm.pickl.responses_left)
                                  )
                                ]
                              ),
                              _c("br"),
                              _vm.pickl.responses_expired > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "pull-right",
                                      staticStyle: { "text-align": "right" }
                                    },
                                    [
                                      _vm._v(
                                        "Responses Expired: " +
                                          _vm._s(_vm.pickl.responses_expired)
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.pickl.responses_expired > 0
                                ? _c("br")
                                : _vm._e(),
                              !_vm.brand
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "pull-right",
                                      staticStyle: { "text-align": "right" }
                                    },
                                    [
                                      _vm._v(
                                        "Average Completion Time: " +
                                          _vm._s(
                                            _vm.pickl.average_completion_time
                                          )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "green-border-box" }, [
                          _vm._m(1),
                          _c("br"),
                          _c(
                            "div",
                            { staticClass: "col-sm-12" },
                            [
                              _vm._l(_vm.pickl.non_geo_pickl_states, function(
                                state
                              ) {
                                return _c(
                                  "span",
                                  {
                                    key: state.id,
                                    staticStyle: {
                                      "font-weight": "bold",
                                      padding: "5px"
                                    }
                                  },
                                  [_vm._v(_vm._s(state.name) + " |")]
                                )
                              }),
                              _c("br"),
                              _c("br")
                            ],
                            2
                          )
                        ]),
                        _c("div", { staticClass: "green-border-box" }, [
                          _vm._m(2),
                          _c("br"),
                          _c("div", { staticClass: "col-sm-12" }, [
                            _c("strong", [
                              _vm._v(
                                "Total App Installed Because Of Pickl: " +
                                  _vm._s(_vm.totalAppInstalled)
                              )
                            ]),
                            _c("br"),
                            _c("strong", [
                              _vm._v(
                                "Already App Installed: " +
                                  _vm._s(_vm.alreadyAppInstalled)
                              )
                            ]),
                            _c("br"),
                            _c("br")
                          ])
                        ]),
                        !_vm.brand
                          ? _c(
                              "div",
                              {
                                staticClass: "green-border-box ",
                                staticStyle: { padding: "1%" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row",
                                    staticStyle: { "margin-bottom": "15px" }
                                  },
                                  [
                                    _vm._m(3),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-sm-9",
                                        staticStyle: { "margin-top": "12px" }
                                      },
                                      [
                                        !_vm.brand &&
                                        _vm.$store.state.userData.role !=
                                          "staff"
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-positive btn-send-message",
                                                attrs: {
                                                  "data-toggle": "modal",
                                                  "data-target":
                                                    "#send-message-popup"
                                                }
                                              },
                                              [_vm._v("Send Message")]
                                            )
                                          : _vm._e(),
                                        !_vm.brand &&
                                        _vm.$store.state.userData.role !=
                                          "staff"
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-positive btn-send-message",
                                                attrs: {
                                                  "data-toggle": "modal",
                                                  "data-target":
                                                    "#send-notification-popup"
                                                }
                                              },
                                              [_vm._v("Send Notification")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                ),
                                _c("ul", { staticClass: "nav nav-tabs" }, [
                                  _c("li", { staticClass: "active" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          "data-toggle": "tab",
                                          href: "#awaiting-approval-tab"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Awaiting Approval (" +
                                            _vm._s(
                                              _vm.pickl.completed_user_pickls
                                                .length
                                            ) +
                                            ")"
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          "data-toggle": "tab",
                                          href: "#approved-tab"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Approved (" +
                                            _vm._s(
                                              _vm.approvedUserList.length
                                            ) +
                                            ")"
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          "data-toggle": "tab",
                                          href: "#rejected-tab"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Rejected (" +
                                            _vm._s(
                                              _vm.pickl.rejected_user_pickls
                                                .length
                                            ) +
                                            ")"
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _c("div", { staticClass: "tab-content" }, [
                                  _c("br"),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tab-pane fade in active",
                                      attrs: { id: "awaiting-approval-tab" }
                                    },
                                    [
                                      _vm.pickl.completed_user_pickls.length > 0
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "send-msg-check"
                                                },
                                                [
                                                  _c("input", {
                                                    staticStyle: {
                                                      "margin-left": "7px"
                                                    },
                                                    attrs: {
                                                      type: "checkbox",
                                                      id:
                                                        "select-all-awaiting-responses"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.toggleSelectAllResponses(
                                                          $event,
                                                          "COMPLETED"
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-label",
                                                      attrs: {
                                                        for:
                                                          "select-all-awaiting-responses"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Select All Awaiting Responses"
                                                      )
                                                    ]
                                                  ),
                                                  _c("br"),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.excludeResponders,
                                                        expression:
                                                          "excludeResponders"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "select-all-approved-responses",
                                                    staticStyle: {
                                                      "margin-left": "7px"
                                                    },
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.excludeResponders
                                                      )
                                                        ? _vm._i(
                                                            _vm.excludeResponders,
                                                            null
                                                          ) > -1
                                                        : _vm.excludeResponders
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm.excludeResponders,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.excludeResponders = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.excludeResponders = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.excludeResponders = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Exclude Completed New Active Campaigns"
                                                      )
                                                    ]
                                                  ),
                                                  _c("br"),
                                                  _c("br")
                                                ]
                                              ),
                                              _vm._l(
                                                _vm.pickl.completed_user_pickls,
                                                function(completedUserPickl) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        completedUserPickl.id,
                                                      staticClass:
                                                        "green-border-box picklr-item"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-12 col-sm-5 profile-details "
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "checkbox",
                                                            staticStyle: {
                                                              position:
                                                                "absolute",
                                                              "margin-left":
                                                                "-13px",
                                                              "margin-top":
                                                                "2px"
                                                            },
                                                            attrs: {
                                                              type: "checkbox"
                                                            },
                                                            domProps: {
                                                              checked: _vm.existsInSelectedUserIds(
                                                                completedUserPickl.user_id
                                                              )
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.toggleUserIdInUserIdsArray(
                                                                  $event,
                                                                  completedUserPickl.user_id
                                                                )
                                                              }
                                                            }
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "green-border-box profile-photo"
                                                            },
                                                            [
                                                              _c("img", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "square-img",
                                                                    rawName:
                                                                      "v-square-img"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  src:
                                                                    _vm.defaultImage
                                                                },
                                                                on: {
                                                                  error:
                                                                    _vm.defaultImage
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "afterImage"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "autosize",
                                                                      rawName:
                                                                        "v-autosize",
                                                                      value: {
                                                                        target: 22,
                                                                        min: 16
                                                                      },
                                                                      expression:
                                                                        "{ target: 22, min: 16 }"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "profile-name"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        completedUserPickl
                                                                          .user
                                                                          .name
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              ),
                                                              !_vm.brand
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "autosize",
                                                                          rawName:
                                                                            "v-autosize",
                                                                          value: {
                                                                            target: 16,
                                                                            min: 16
                                                                          },
                                                                          expression:
                                                                            "{ target: 16, min: 16 }"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "phone-number"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "phone"
                                                                            )(
                                                                              completedUserPickl
                                                                                .user
                                                                                .mobile_number
                                                                            )
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-12 col-sm-3 date-time"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Completed On"
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formattedPhpTime"
                                                                )(
                                                                  completedUserPickl.created_at
                                                                )
                                                              ) +
                                                              "\n                          | " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "fullDate"
                                                                )(
                                                                  completedUserPickl.created_at
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-12 col-sm-3 nopadd"
                                                        },
                                                        [
                                                          !_vm.brand
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn-lg-green pull-right",
                                                                  staticStyle: {
                                                                    background:
                                                                      "rgb(211, 107, 0)"
                                                                  },
                                                                  attrs: {
                                                                    "data-target":
                                                                      "#user-pickl-details-popup",
                                                                    "data-toggle":
                                                                      "modal"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.getUserPicklInfo(
                                                                        completedUserPickl.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            APPROVE/VIEW\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _c(
                                            "h3",
                                            {
                                              staticStyle: {
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      No Awaiting approval pickl found!\n                    "
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tab-pane fade in",
                                      attrs: { id: "approved-tab" }
                                    },
                                    [
                                      _vm.pickl.approved_user_pickls.length > 0
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "send-msg-check"
                                                },
                                                [
                                                  _c("input", {
                                                    staticClass:
                                                      "select-all-approved-responses",
                                                    staticStyle: {
                                                      "margin-left": "7px"
                                                    },
                                                    attrs: { type: "checkbox" },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.toggleSelectAllResponses(
                                                          $event,
                                                          "APPROVED"
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-label",
                                                      attrs: {
                                                        for:
                                                          "select-all-approved-responses"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Select All Approved Responses"
                                                      )
                                                    ]
                                                  ),
                                                  _c("br"),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.excludeResponders,
                                                        expression:
                                                          "excludeResponders"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "select-all-approved-responses",
                                                    staticStyle: {
                                                      "margin-left": "7px"
                                                    },
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.excludeResponders
                                                      )
                                                        ? _vm._i(
                                                            _vm.excludeResponders,
                                                            null
                                                          ) > -1
                                                        : _vm.excludeResponders
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm.excludeResponders,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.excludeResponders = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.excludeResponders = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.excludeResponders = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Exclude Completed New Active Campaigns"
                                                      )
                                                    ]
                                                  ),
                                                  _c("br"),
                                                  _c("br")
                                                ]
                                              ),
                                              _vm._l(
                                                _vm.approvedUserList,
                                                function(approvedUserPickl) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: approvedUserPickl.id,
                                                      staticClass:
                                                        "green-border-box picklr-item"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-12 col-sm-5 profile-details "
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "checkbox",
                                                            staticStyle: {
                                                              position:
                                                                "absolute",
                                                              "margin-left":
                                                                "-13px",
                                                              "margin-top":
                                                                "2px"
                                                            },
                                                            attrs: {
                                                              type: "checkbox"
                                                            },
                                                            domProps: {
                                                              checked: _vm.existsInSelectedUserIds(
                                                                approvedUserPickl.user_id
                                                              )
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.toggleUserIdInUserIdsArray(
                                                                  $event,
                                                                  approvedUserPickl.user_id
                                                                )
                                                              }
                                                            }
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "green-border-box profile-photo"
                                                            },
                                                            [
                                                              _c("img", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "square-img",
                                                                    rawName:
                                                                      "v-square-img"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  src:
                                                                    _vm.defaultImage
                                                                },
                                                                on: {
                                                                  error:
                                                                    _vm.defaultImage
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "afterImage"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "autosize",
                                                                      rawName:
                                                                        "v-autosize",
                                                                      value: {
                                                                        target: 22,
                                                                        min: 16
                                                                      },
                                                                      expression:
                                                                        "{ target: 22, min: 16 }"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "profile-name"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        approvedUserPickl
                                                                          .user
                                                                          .name
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              ),
                                                              !_vm.brand
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "autosize",
                                                                          rawName:
                                                                            "v-autosize",
                                                                          value: {
                                                                            target: 16,
                                                                            min: 16
                                                                          },
                                                                          expression:
                                                                            "{ target: 16, min: 16 }"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "phone-number"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "phone"
                                                                            )(
                                                                              approvedUserPickl
                                                                                .user
                                                                                .mobile_number
                                                                            )
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-12 col-sm-3 date-time"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Approved On"
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formattedPhpTime"
                                                                )(
                                                                  approvedUserPickl.updated_at
                                                                )
                                                              ) +
                                                              "\n                          | " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "fullDate"
                                                                )(
                                                                  approvedUserPickl.updated_at
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-12 col-sm-3 nopadd"
                                                        },
                                                        [
                                                          !_vm.brand
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn-lg-green pull-right",
                                                                  attrs: {
                                                                    "data-target":
                                                                      "#user-pickl-details-popup",
                                                                    "data-toggle":
                                                                      "modal"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.getUserPicklInfo(
                                                                        approvedUserPickl.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            VIEW\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _c(
                                            "h3",
                                            {
                                              staticStyle: {
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      No approved pickls found!\n                    "
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tab-pane fade in",
                                      attrs: { id: "rejected-tab" }
                                    },
                                    [
                                      _vm.pickl.rejected_user_pickls.length > 0
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "send-msg-check"
                                                },
                                                [
                                                  _c("input", {
                                                    staticClass:
                                                      "select-all-rejected-responses",
                                                    staticStyle: {
                                                      "margin-left": "7px"
                                                    },
                                                    attrs: { type: "checkbox" },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.toggleSelectAllResponses(
                                                          $event,
                                                          "REJECTED"
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-label",
                                                      attrs: {
                                                        for:
                                                          "select-all-rejected-responses"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Select All REJECTED Responses"
                                                      )
                                                    ]
                                                  ),
                                                  _c("br"),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.excludeResponders,
                                                        expression:
                                                          "excludeResponders"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "select-all-approved-responses",
                                                    staticStyle: {
                                                      "margin-left": "7px"
                                                    },
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.excludeResponders
                                                      )
                                                        ? _vm._i(
                                                            _vm.excludeResponders,
                                                            null
                                                          ) > -1
                                                        : _vm.excludeResponders
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm.excludeResponders,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.excludeResponders = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.excludeResponders = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.excludeResponders = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Exclude Completed New Active Campaigns"
                                                      )
                                                    ]
                                                  ),
                                                  _c("br"),
                                                  _c("br")
                                                ]
                                              ),
                                              _vm._l(
                                                _vm.pickl.rejected_user_pickls,
                                                function(rejectedUserPickl) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: rejectedUserPickl.id,
                                                      staticClass:
                                                        "green-border-box picklr-item"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-12 col-sm-5 profile-details "
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "checkbox",
                                                            staticStyle: {
                                                              position:
                                                                "absolute",
                                                              "margin-left":
                                                                "-13px",
                                                              "margin-top":
                                                                "2px"
                                                            },
                                                            attrs: {
                                                              type: "checkbox"
                                                            },
                                                            domProps: {
                                                              checked: _vm.existsInSelectedUserIds(
                                                                rejectedUserPickl.user_id
                                                              )
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.toggleUserIdInUserIdsArray(
                                                                  $event,
                                                                  rejectedUserPickl.user_id
                                                                )
                                                              }
                                                            }
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "green-border-box profile-photo"
                                                            },
                                                            [
                                                              _c("img", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "square-img",
                                                                    rawName:
                                                                      "v-square-img"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  src:
                                                                    _vm.defaultImage
                                                                },
                                                                on: {
                                                                  error:
                                                                    _vm.defaultImage
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "afterImage"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "autosize",
                                                                      rawName:
                                                                        "v-autosize",
                                                                      value: {
                                                                        target: 22,
                                                                        min: 16
                                                                      },
                                                                      expression:
                                                                        "{ target: 22, min: 16 }"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "profile-name"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        rejectedUserPickl
                                                                          .user
                                                                          .name
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              ),
                                                              !_vm.brand
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "autosize",
                                                                          rawName:
                                                                            "v-autosize",
                                                                          value: {
                                                                            target: 16,
                                                                            min: 16
                                                                          },
                                                                          expression:
                                                                            "{ target: 16, min: 16 }"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "phone-number"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "phone"
                                                                            )(
                                                                              rejectedUserPickl
                                                                                .user
                                                                                .mobile_number
                                                                            )
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-12 col-sm-3 date-time"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Approved On"
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formattedPhpTime"
                                                                )(
                                                                  rejectedUserPickl.created_at
                                                                )
                                                              ) +
                                                              "\n                          | " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "fullDate"
                                                                )(
                                                                  rejectedUserPickl.created_at
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-12 col-sm-3 nopadd"
                                                        },
                                                        [
                                                          !_vm.brand
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn-lg-green pull-right",
                                                                  attrs: {
                                                                    "data-target":
                                                                      "#user-pickl-details-popup",
                                                                    "data-toggle":
                                                                      "modal"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.getUserPicklInfo(
                                                                        rejectedUserPickl.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            VIEW\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _c(
                                            "h3",
                                            {
                                              staticStyle: {
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      No rejected pickls found!\n                    "
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "green-border-box ",
                                staticStyle: { padding: "1%" }
                              },
                              [
                                _c("h3", [
                                  _vm._v(
                                    "\n                  User Responses\n                "
                                  )
                                ]),
                                _c("ul", { staticClass: "nav nav-tabs" }, [
                                  _c("li", { staticClass: "active" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          "data-toggle": "tab",
                                          href: "#all-tab"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "All (" +
                                            _vm._s(
                                              _vm.pickl.approved_user_pickls
                                                .length
                                            ) +
                                            ")"
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._m(4)
                                ]),
                                _c("div", { staticClass: "tab-content" }, [
                                  _c("br"),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tab-pane fade in active",
                                      attrs: { id: "all-tab" }
                                    },
                                    [
                                      _vm.pickl.approved_user_pickls.length > 0
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              _vm.pickl.approved_user_pickls,
                                              function(approvedUserPickl) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: approvedUserPickl.id,
                                                    staticClass:
                                                      "green-border-box picklr-item"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-xs-12 col-sm-5 profile-details "
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "green-border-box profile-photo"
                                                          },
                                                          [
                                                            _c("img", {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "square-img",
                                                                  rawName:
                                                                    "v-square-img"
                                                                }
                                                              ],
                                                              attrs: {
                                                                src:
                                                                  _vm.defaultImage
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.defaultImage
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "afterImage"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "autosize",
                                                                    rawName:
                                                                      "v-autosize",
                                                                    value: {
                                                                      target: 22,
                                                                      min: 16
                                                                    },
                                                                    expression:
                                                                      "{ target: 22, min: 16 }"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "profile-name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      approvedUserPickl
                                                                        .user
                                                                        .name
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            ),
                                                            !_vm.brand
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "autosize",
                                                                        rawName:
                                                                          "v-autosize",
                                                                        value: {
                                                                          target: 16,
                                                                          min: 16
                                                                        },
                                                                        expression:
                                                                          "{ target: 16, min: 16 }"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "phone-number"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "phone"
                                                                          )(
                                                                            approvedUserPickl
                                                                              .user
                                                                              .mobile_number
                                                                          )
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-xs-12 col-sm-3 date-time"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Completed On"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formattedPhpTime"
                                                              )(
                                                                approvedUserPickl.updated_at
                                                              )
                                                            ) +
                                                            "\n                          | " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "fullDate"
                                                              )(
                                                                approvedUserPickl.updated_at
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-xs-12 col-sm-3 nopadd"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn-lg-green pull-right",
                                                            attrs: {
                                                              "data-target":
                                                                "#user-pickl-details-popup",
                                                              "data-toggle":
                                                                "modal"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.getUserPicklInfo(
                                                                  approvedUserPickl.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            VIEW\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _c(
                                            "h3",
                                            {
                                              staticStyle: {
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      No completed pickls found!\n                    "
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tab-pane fade in",
                                      attrs: { id: "attention-needed-tab" }
                                    },
                                    [
                                      _vm.pickl.approved_user_pickls.length > 0
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              _vm.pickl.approved_user_pickls,
                                              function(approvedUserPickl) {
                                                return _c(
                                                  "div",
                                                  { key: approvedUserPickl.id },
                                                  [
                                                    approvedUserPickl.need_review ==
                                                    "Yes"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "green-border-box picklr-item"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-xs-12 col-sm-5 profile-details "
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "green-border-box profile-photo"
                                                                  },
                                                                  [
                                                                    _c("img", {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "square-img",
                                                                          rawName:
                                                                            "v-square-img"
                                                                        }
                                                                      ],
                                                                      attrs: {
                                                                        src:
                                                                          _vm.defaultImage
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.defaultImage
                                                                      }
                                                                    })
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "afterImage"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "autosize",
                                                                            rawName:
                                                                              "v-autosize",
                                                                            value: {
                                                                              target: 22,
                                                                              min: 16
                                                                            },
                                                                            expression:
                                                                              "{ target: 22, min: 16 }"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "profile-name"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              " +
                                                                            _vm._s(
                                                                              approvedUserPickl
                                                                                .user
                                                                                .name
                                                                            ) +
                                                                            "\n                            "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    !_vm.brand
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "autosize",
                                                                                rawName:
                                                                                  "v-autosize",
                                                                                value: {
                                                                                  target: 16,
                                                                                  min: 16
                                                                                },
                                                                                expression:
                                                                                  "{ target: 16, min: 16 }"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "phone-number"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  _vm._f(
                                                                                    "phone"
                                                                                  )(
                                                                                    approvedUserPickl
                                                                                      .user
                                                                                      .mobile_number
                                                                                  )
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-xs-12 col-sm-3 date-time"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          Completed On"
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formattedPhpTime"
                                                                      )(
                                                                        approvedUserPickl.updated_at
                                                                      )
                                                                    ) +
                                                                    "\n                          | " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "fullDate"
                                                                      )(
                                                                        approvedUserPickl.updated_at
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-xs-12 col-sm-3 nopadd"
                                                              },
                                                              [
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn-lg-green pull-right",
                                                                    attrs: {
                                                                      "data-target":
                                                                        "#user-pickl-details-popup",
                                                                      "data-toggle":
                                                                        "modal"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.getUserPicklInfo(
                                                                          approvedUserPickl.id
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            VIEW\n                          "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _c(
                                            "h3",
                                            {
                                              staticStyle: {
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      No completed pickls found!\n                    "
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                ])
                              ]
                            )
                      ])
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    attrs: { id: "survey-details-section" }
                  },
                  [
                    _c("br"),
                    _c("PicklStats", {
                      attrs: {
                        surveyId: _vm.surveyId,
                        basicSurveyDetails: _vm.basicSurveyDetails,
                        brandId: _vm.brandId,
                        totalResponsesAnswers: _vm.totalResponsesAnswers,
                        pickl: _vm.pickl
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _c("NonGeoUserPicklDetailsPopup", {
            attrs: {
              userPicklId: _vm.userPicklId,
              popupId: "user-pickl-details-popup",
              brand: _vm.brand,
              nonGeoPicklDetails: _vm.selectedUserPickl,
              loadingUserPicklDetails: _vm.loadingUserPicklDetails
            },
            on: {
              statusUpdated: function($event) {
                return _vm.getNonGeoPicklDetails()
              }
            }
          }),
          _c("SendMessagePopup", {
            attrs: {
              popupId: "send-message-popup",
              checkedUsersList: _vm.selectedUserIds,
              excludeResponders: _vm.excludeResponders,
              picklId: _vm.pickl.id,
              selectAllPicklrs: false,
              picklrFilters: {}
            },
            on: { messageSent: _vm.messageSent }
          }),
          _c("SendCustomNotificationPopup", {
            attrs: {
              popupId: "send-notification-popup",
              checkedUsersList: _vm.selectedUserIds,
              excludeResponders: _vm.excludeResponders,
              picklId: _vm.pickl.id,
              selectAllPicklrs: false,
              picklrFilters: {}
            },
            on: { notificationSent: _vm.messageSent }
          }),
          _c("DeletePicklPopup", {
            attrs: { popupId: "deletepicklpopup", picklId: _vm.pickl.id },
            on: { picklDeleted: _vm.redirectToPicklsPage }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "nav nav-tabs" }, [
      _c("li", { staticClass: "active" }, [
        _c(
          "a",
          { attrs: { "data-toggle": "tab", href: "#pickl-details-section" } },
          [_vm._v("Pickl Details")]
        )
      ]),
      _c("li", [
        _c(
          "a",
          { attrs: { "data-toggle": "tab", href: "#survey-details-section" } },
          [_vm._v("Pickl Stats")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      { staticStyle: { "margin-left": "10px", "margin-right": "10px" } },
      [
        _c("span", { staticStyle: { float: "left" } }, [
          _c("strong", [_vm._v("States Launched:")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      { staticStyle: { "margin-left": "10px", "margin-right": "10px" } },
      [
        _c("span", { staticStyle: { float: "left" } }, [
          _c("strong", [_vm._v("App Installation Stats:")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-3" }, [
      _c("h3", [
        _vm._v("\n                      User Responses\n                    ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { "data-toggle": "tab", href: "#attention-needed-tab" } },
        [_vm._v("Attention Needed")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }